import { render } from "./NavBar.vue?vue&type=template&id=0da46d40"
const script = {}

import "./NavBar.vue?vue&type=style&index=0&id=0da46d40&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__